import {
  Modal,
  ModalOverlay,
  ModalContent,
  Box,
  Link,
  Text,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  Button,
  Img,
  useDisclosure,
  Heading,
  ButtonGroup,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuOptionGroup,
  Divider,
  Input,
  Textarea,
  Select,
  RadioGroup,
  Stack,
  Radio,
  List,
  ListItem,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";

import moreInsightsImage from "../../assets/images/more-insights.png";
import ratingLikeImage from "../../assets/images/rating-like.png";
import { usePayment } from "../../contexts/PaymentContext";
// import {
//   getEarlyBirdApi,
//   initiatePayment,
//   registerEarlyBirdApi,
//   verifyPayment,
// } from "../api/agencyApi";
// import { refreshUserWithoutNavigate } from "../actions/user/userActions";
// import {
//   initiateClientDashboardPurchase,
//   verifyClientDashboardPurchasePayment,
// } from "../api/organisationApi";
import party_popper from "../../assets/images/party-popper.png";
import party_box from "../../assets/images/party-box.png";
import flash from "../../assets/images/flash.png";
import SMMBasicIcon from "../../components/Icons/SMMBasicIcon";

import "./PaymentModel.scss";
import { errMsg } from "../../utils/helperFunction";
import { toast } from "react-toastify";
import { getEarlyBirdOffer } from "../../actions/user/userActions";
import { getPricing } from "../../actions/pricing/pricingActions";
import Loader from "../../components/Loader/Loader";
import { initiateOrderApi, verifyOrderPayment } from "../../api/orderApi";
import { getUserOrders } from "../../actions/order/orderActions";
import { registerEarlyBirdOfferApi } from "../../api/userApi";
import CheckIcon from "../../components/Icons/CheckIcon";
import CrossIcon from "../../components/Icons/CrossIcon";
import SMMProEndIcon from "../../components/Icons/SMMProEndIcon";
import SMMProStartIcon from "../../components/Icons/SMMProStartIcon";
// import { useNavigate } from "react-router-dom";

const Step1Component = ({ setStep }) => {
  return (
    <ModalContent py="10" px="15" position="relative">
      <ModalHeader fontSize="28px" fontWeight="700" color={"#0C543C"}>
        Add Client Dashboards
      </ModalHeader>
      <ModalCloseButton
        position="absolute"
        top="-15px"
        height="42px"
        width="42px"
        right="-15px"
        background="#fff"
        borderRadius="50px"
        boxShadow="-4px -4px 18px rgba(0, 0, 0, 0.4)"
      />
      <ModalBody>
        <Flex>
          <Img
            src={moreInsightsImage}
            alt="More Insights Image"
            h={"111.59px"}
            w={"130.56px"}
          />
          <Box display="flex" flexDir="column" justifyContent="center" pl={8}>
            <Heading
              fontSize="24px"
              color="#1E1E1E"
              fontWeight={600}
              textColor={"#162421"}
            >
              More Insights
            </Heading>
            <Text fontWeight="400" color="#000000" mt={2} fontSize={16}>
              Expand your clientele and make better decisions
            </Text>
          </Box>
        </Flex>

        <Flex mt={10}>
          <Img
            src={ratingLikeImage}
            alt="More Insights Image"
            h={"118px"}
            w={"123px"}
          />
          <Box display="flex" flexDir="column" justifyContent="center" pl={8}>
            <Heading
              fontSize="24px"
              color="#1E1E1E"
              fontWeight={600}
              textColor={"#162421"}
            >
              At your fingertips
            </Heading>
            <Text fontWeight="400" color="#000000" mt={2} fontSize={16}>
              Find all your clients and their business insights, any time, any
              place
            </Text>
          </Box>
        </Flex>
      </ModalBody>

      <ModalFooter justifyContent="center" mt={12}>
        <Button
          bg="#0C543C"
          color={"white"}
          mr={3}
          onClick={() => setStep(2)}
          fontSize="18px"
          fontWeight={700}
          px={10}
        >
          Buy Client Dashboards
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};

const StepPlanSubcriptionComponent = ({ setStep }) => {
  const dispatch = useDispatch();

  const { loading: earlyBirdOfferLoading, data: earlyBirdOfferData } =
    useSelector((state) => state.earlyBirdOfferReducer);

  const { loading: pricingLoading, data: pricingData } = useSelector(
    (state) => state.pricingReducer
  );

  const { showPaymentModal, hidePaymentModal } = usePayment();
  const { data: userData } = useSelector((state) => state.userReducer);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [earlyBirdRemaining, setEarlyBirdRemaining] = useState(0);
  const [earlyBirdCurrent, setEarlyBirdCurrent] = useState();
  const [earlyBirdFlag, setEarlyBirdFlag] = useState(false);
  const [answer1, setAnswer1] = useState("");
  const [answer2, setAnswer2] = useState("");
  const [answer3, setAnswer3] = useState("");
  const [answer4, setAnswer4] = useState("");
  const [answer5a, setAnswer5a] = useState("");
  const [answer5b, setAnswer5b] = useState("");
  const [answer1Flag, setAnswer1Flag] = useState(true);
  const [answer2Flag, setAnswer2Flag] = useState(false);
  const [answer3Flag, setAnswer3Flag] = useState(false);
  const [answer4Flag, setAnswer4Flag] = useState(false);
  const [answer5Flag, setAnswer5Flag] = useState(false);
  const [answer1ErrorFlag, setAnswer1ErrorFlag] = useState(false);
  const [answer2ErrorFlag, setAnswer2ErrorFlag] = useState(false);
  const [answer3ErrorFlag, setAnswer3ErrorFlag] = useState(false);
  const [answer4ErrorFlag, setAnswer4ErrorFlag] = useState(false);
  const [answer5aErrorFlag, setAnswer5aErrorFlag] = useState(false);
  const [answer5bErrorFlag, setAnswer5bErrorFlag] = useState(false);
  const [subscriptionAmount1, setSubscriptionAmount1] = useState(0);
  const [subscriptionAmount, setSubscriptionAmount] = useState(0);
  const [subscriptionOffer, setSubscriptionOffer] = useState({});
  const [subscriptionAmountSuffix1, setSubscriptionAmountSuffix1] =
    useState("monthly");

  const formattedCurrency = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(subscriptionAmount1);

  const discountAmount = (sequence, subscriptionType, originalAmount) => {
    let returnOffer = {
      originalAmount: subscriptionAmount1,
    };
    if (sequence >= 1 && sequence <= 10) {
      if (subscriptionType === "monthly") {
        returnOffer = {
          offerDiscountPer: 40,
          originalAmount: originalAmount,
          offerDiscountAmount: originalAmount * 0.6,
        };
      } else if (subscriptionType === "quarterly") {
        returnOffer = {
          offerDiscountPer: 50,
          originalAmount: originalAmount,
          offerDiscountAmount: originalAmount * 0.5,
        };
      } else {
        returnOffer = {
          offerDiscountPer: 60,
          originalAmount: originalAmount,
          offerDiscountAmount: originalAmount * 0.4,
        };
      }
    } else if (sequence >= 11 && sequence <= 30) {
      if (subscriptionType === "monthly") {
        returnOffer = {
          offerDiscountPer: 30,
          originalAmount: originalAmount,
          offerDiscountAmount: originalAmount * 0.7,
        };
      } else if (subscriptionType === "quarterly") {
        returnOffer = {
          offerDiscountPer: 40,
          originalAmount: originalAmount,
          offerDiscountAmount: originalAmount * 0.6,
        };
      } else {
        returnOffer = {
          offerDiscountPer: 50,
          originalAmount: originalAmount,
          offerDiscountAmount: originalAmount * 0.5,
        };
      }
    }
    return returnOffer;
  };
  const offerAmount = (sequence) => {
    let returnOffer = {
      originalAmount: subscriptionAmount1,
    };
    if (sequence >= 1 && sequence <= 10) {
      if (subscriptionAmountSuffix1 === "monthly") {
        returnOffer = {
          offerDiscountPer: 40,
          originalAmount: subscriptionAmount1,
          offerDiscountAmount: subscriptionAmount1 * 0.6,
        };
      } else if (subscriptionAmountSuffix1 === "quarterly") {
        returnOffer = {
          offerDiscountPer: 50,
          originalAmount: subscriptionAmount1,
          offerDiscountAmount: subscriptionAmount1 * 0.5,
        };
      } else {
        returnOffer = {
          offerDiscountPer: 60,
          originalAmount: subscriptionAmount1,
          offerDiscountAmount: subscriptionAmount1 * 0.4,
        };
      }
    } else if (sequence >= 11 && sequence <= 30) {
      if (subscriptionAmountSuffix1 === "monthly") {
        returnOffer = {
          offerDiscountPer: 30,
          originalAmount: subscriptionAmount1,
          offerDiscountAmount: subscriptionAmount1 * 0.7,
        };
      } else if (subscriptionAmountSuffix1 === "quarterly") {
        returnOffer = {
          offerDiscountPer: 40,
          originalAmount: subscriptionAmount1,
          offerDiscountAmount: subscriptionAmount1 * 0.6,
        };
      } else {
        returnOffer = {
          offerDiscountPer: 50,
          originalAmount: subscriptionAmount1,
          offerDiscountAmount: subscriptionAmount1 * 0.5,
        };
      }
    }
    return returnOffer;
  };
  const handlePayment = async (paymentPlan) => {
    setSelectedPlan(paymentPlan?._id);
    const discount_amount = discountAmount(
      earlyBirdCurrent,
      subscriptionAmountSuffix1,
      paymentPlan?.priceRange.account.amount
    )?.offerDiscountAmount;
    const amount = discount_amount
      ? discount_amount
      : paymentPlan?.priceRange.account.amount;
    let response = null;
    response = await initiateOrderApi({
      paymentPlanId: paymentPlan?._id,
      paymentFrequency: subscriptionAmountSuffix1,
      amount: parseFloat(amount) * 100,
      paymentMethod: "razorpay",
    });
    if (response?.razorpay && response.razorpay.razorpayOrderId) {
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: parseFloat(response.amount) * 100,
        currency: "INR",
        name: "Sylvr",
        description: "Payment for purchase of new dashboards",
        order_id: response.razorpay.razorpayOrderId,
        handler: async function (paymentResponse) {
          await verifyOrderPayment({
            razorpay_payment_id: paymentResponse.razorpay_payment_id,
            razorpay_order_id: paymentResponse.razorpay_order_id,
            razorpay_signature: paymentResponse.razorpay_signature,
            paymentMethod: "razorpay",
          });

          showPaymentModal();
          setStep(3);
        },
        prefill: {
          name: userData.name,
          email: userData.email,
          contact: "1234567890",
        },
      };

      hidePaymentModal();

      const paymentObject = new window.Razorpay(options);

      paymentObject.on("payment.failed", function (response) {
        alert(response.error.description);
      });

      paymentObject.open();
    } else {
      setStep(3);
    }
    dispatch(getUserOrders());
  };
  const handleEarlyBird = async () => {
    if (answer5a === "") {
      setAnswer5aErrorFlag(true);
    } else if (answer5b === "") {
      setAnswer5aErrorFlag(false);
      setAnswer5bErrorFlag(true);
    } else {
      setAnswer1("");
      setAnswer2("");
      setAnswer3("");
      setAnswer4("");
      setAnswer5a("");
      setAnswer5b("");
      setAnswer5aErrorFlag(false);
      setAnswer1Flag(true);
      setAnswer5Flag(false);
      setAnswer5bErrorFlag(false);
      setEarlyBirdFlag(false);
      try {
        const { message, data } = await registerEarlyBirdOfferApi({
          answer1,
          answer2,
          answer3,
          answer4,
          answer5a,
          answer5b: parseInt(answer5b),
        });
        toast.info(message, {
          toastId: message,
          position: "bottom-center",
        });
        dispatch(getEarlyBirdOffer());
        setSubscriptionOffer(offerAmount(data?.sequence));
        // setSubscriptionAmount1(5000);
        setEarlyBirdCurrent(data?.sequence);
        setEarlyBirdRemaining(data?.remaining);
      } catch (err) {
        const message = errMsg(err);
        toast.error(message, {
          toastId: message,
          position: "bottom-center",
        });
      }
    }
  };
  useEffect(() => {
    dispatch(getEarlyBirdOffer());
    dispatch(getPricing());
  }, []);
  useEffect(() => {
    if (!earlyBirdOfferLoading && earlyBirdOfferData) {
      setEarlyBirdCurrent(earlyBirdOfferData?.sequence);
      setSubscriptionOffer(offerAmount(earlyBirdOfferData?.sequence));
    }
  }, [earlyBirdOfferLoading]);

  console.log("=====pricingLoading, pricingData", pricingLoading, pricingData);
  useEffect(() => {
    setSubscriptionOffer(offerAmount(earlyBirdCurrent));
  }, [subscriptionAmountSuffix1]);
  return earlyBirdFlag ? (
    <ModalContent className="earlyBird" position="relative">
      <ModalCloseButton className="close-btn" />
      <ModalBody>
        <Box
          className="plan-block"
          margin={"15px"}
          justifyContent={"space-around"}
          display={"inline-flex"}
          minH={"200px"}
        >
          {answer1Flag && (
            <Box width={"100%"}>
              <Box m={"15px 5px"}>
                For your Advisory practice to succeed, <b>what</b> is{" "}
                <i style={{ textDecoration: "underline" }}>the one project</i>{" "}
                you really need to accomplish
              </Box>
              <Box m={"15px 5px"}>
                <Textarea
                  onChange={(e) => setAnswer1(e.target.value)}
                  value={answer1}
                />
                {answer1ErrorFlag && (
                  <span style={{ color: "orange" }}>Please enter value</span>
                )}
              </Box>
              <Flex justifyContent={"space-around"}>
                <Box>
                  <Button
                    onClick={() => {
                      if (answer1 === "") {
                        setAnswer1ErrorFlag(true);
                      } else {
                        setAnswer1ErrorFlag(false);
                        setAnswer1Flag(false);
                        setAnswer2Flag(true);
                      }
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </Flex>
            </Box>
          )}
          {answer2Flag && (
            <Box width={"100%"}>
              <Box m={"15px 5px"}>
                <b>Why</b> do you need to accomplish{" "}
                <i style={{ textDecoration: "underline" }}>this specifically</i>{" "}
                vs everything else possible
              </Box>
              <Box m={"15px 5px"}>
                <Textarea
                  onChange={(e) => setAnswer2(e.target.value)}
                  value={answer2}
                />
                {answer2ErrorFlag && (
                  <span style={{ color: "orange" }}>Please enter value</span>
                )}
              </Box>
              <Flex justifyContent={"space-around"}>
                <Box>
                  <Button
                    onClick={() => {
                      setAnswer1Flag(true);
                      setAnswer2Flag(false);
                    }}
                  >
                    Previous
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      if (answer2 === "") {
                        setAnswer2ErrorFlag(true);
                      } else {
                        setAnswer2ErrorFlag(false);
                        setAnswer2Flag(false);
                        setAnswer3Flag(true);
                      }
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </Flex>
            </Box>
          )}
          {answer3Flag && (
            <Box width={"100%"}>
              <Box m={"15px 5px"}>
                <b>What</b> will success look like? <b>How</b> will you{" "}
                <i style={{ textDecoration: "underline" }}>know</i> you have
                accomplished it, no going back?
              </Box>
              <Box m={"15px 5px"}>
                <Textarea
                  onChange={(e) => setAnswer3(e.target.value)}
                  value={answer3}
                />
                {answer3ErrorFlag && (
                  <span style={{ color: "orange" }}>Please enter value</span>
                )}
              </Box>
              <Flex justifyContent={"space-around"}>
                <Box>
                  <Button
                    onClick={() => {
                      setAnswer2Flag(true);
                      setAnswer3Flag(false);
                    }}
                  >
                    Previous
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      if (answer3 === "") {
                        setAnswer3ErrorFlag(true);
                      } else {
                        setAnswer3ErrorFlag(false);
                        setAnswer3Flag(false);
                        setAnswer4Flag(true);
                      }
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </Flex>
            </Box>
          )}
          {answer4Flag && (
            <Box width={"100%"}>
              <Box m={"15px 5px"}>
                <b>What</b>{" "}
                <i style={{ textDecoration: "underline" }}>options</i> do you
                consider to accomplish this
              </Box>
              <Box m={"15px 5px"}>
                <Textarea
                  onChange={(e) => setAnswer4(e.target.value)}
                  value={answer4}
                />
                {answer4ErrorFlag && (
                  <span style={{ color: "orange" }}>Please enter value</span>
                )}
              </Box>
              <Flex justifyContent={"space-around"}>
                <Box>
                  <Button
                    onClick={() => {
                      setAnswer3Flag(true);
                      setAnswer4Flag(false);
                    }}
                  >
                    Previous
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      if (answer4 === "") {
                        setAnswer4ErrorFlag(true);
                      } else {
                        setAnswer4ErrorFlag(false);
                        setAnswer4Flag(false);
                        setAnswer5Flag(true);
                      }
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </Flex>
            </Box>
          )}
          {answer5Flag && (
            <Box width={"100%"}>
              <Box m={"15px 5px"}>
                [Scene: After lot of research, you have found the most optimum
                option.]
                <br></br>
                Enter the <b>maximum price</b> you would{" "}
                <i style={{ textDecoration: "underline" }}>pay</i>
              </Box>
              <Flex m={"15px 5px"} justifyContent={"space-around"}>
                <Box>
                  <Box>
                    <Select
                      focusBorderColor="primary.400"
                      size={"sm"}
                      ml={"10px"}
                      borderRadius={"10px"}
                      w={"120px"}
                      onChange={(e) => setAnswer5a(e.target.value)}
                    >
                      <option value={""}>--Select--</option>
                      {["One-time", "Monthly", "Quarterly", "Half-yearly"].map(
                        (frequency, index) => (
                          <option key={index} value={frequency}>
                            {frequency}
                          </option>
                        )
                      )}
                    </Select>
                  </Box>
                  {answer5aErrorFlag && (
                    <span style={{ color: "orange" }}>Please select value</span>
                  )}
                </Box>
                <Box>
                  <Input
                    onChange={(e) => setAnswer5b(e.target.value)}
                    placeholder="Enter the maximum price"
                    value={answer5b}
                  />
                  {answer5bErrorFlag && (
                    <span style={{ color: "orange" }}>Please select value</span>
                  )}
                </Box>
              </Flex>
              <Flex justifyContent={"space-around"}>
                <Box>
                  <Button
                    onClick={() => {
                      setAnswer4Flag(true);
                      setAnswer5Flag(false);
                    }}
                  >
                    Previous
                  </Button>
                </Box>
                <Box>
                  <Button onClick={handleEarlyBird}>Submit</Button>
                </Box>
              </Flex>
            </Box>
          )}
        </Box>
      </ModalBody>
    </ModalContent>
  ) : (
    <ModalContent position="relative" maxW={"90%"}>
      <ModalHeader className="payment-title" paddingBottom={"0px"}>
        Focus on advisory without frustrations of searching industry PDFs,
        purchasing & cleaning datasets for competitive research and doubts of
        data inaccuracy.
      </ModalHeader>
      {earlyBirdOfferLoading &&
      earlyBirdOfferData &&
      earlyBirdOfferData?.sequence > 0 &&
      earlyBirdOfferData?.sequence <= 30 ? (
        <>
          <Flex className="payment-early-bird" alignItems={"center"}>
            <Box className="payment-early-bird-image">
              <Img
                src={party_popper}
                alt="Party Popper"
                h={"24px"}
                w={"24px"}
              />
            </Box>
            <Box>
              <Box className="payment-early-bird-text">
                Early Bird Offer Activated. Enjoy!
              </Box>
            </Box>
            <Box className="payment-early-bird-image">
              <Img
                src={party_popper}
                alt="Party Popper"
                h={"24px"}
                w={"24px"}
              />
            </Box>
          </Flex>
        </>
      ) : (
        <>
          {!earlyBirdOfferLoading &&
            earlyBirdOfferData &&
            earlyBirdOfferData?.remaining > 0 && (
              <>
                <Flex className="payment-early-bird">
                  <Box className="payment-early-bird-image">
                    <Img
                      src={party_box}
                      alt="Party Popper"
                      h={"20px"}
                      w={"20px"}
                    />
                  </Box>
                  <Box>
                    <Box
                      className="payment-early-bird-link"
                      onClick={() => setEarlyBirdFlag(true)}
                    >
                      Grab the Early Bird Offer ( 30-60% by taking a survey )
                    </Box>
                  </Box>
                  <Box className="payment-early-bird-image">
                    <Img
                      src={party_box}
                      alt="Party Popper"
                      h={"20px"}
                      w={"20px"}
                    />
                  </Box>
                </Flex>
                <Flex className="payment-early-bird" alignItems={"center"}>
                  <Box className="payment-early-bird-image">
                    <Img src={flash} alt="Party Popper" h={"18px"} w={"15px"} />
                  </Box>
                  <Box>
                    Only {earlyBirdOfferData?.remaining} seats remaining
                  </Box>
                  <Box className="payment-early-bird-image">
                    <Img src={flash} alt="Party Popper" h={"18px"} w={"15px"} />
                  </Box>
                </Flex>
              </>
            )}
        </>
      )}
      <ModalCloseButton className="close-btn" />
      <ModalBody>
        {/* <Box margin={"5px 22px"}>
          <RadioGroup defaultValue="1">
            <Stack spacing={4} direction="row">
              <Radio
                value="1"
                onClick={() => {
                  setSubscriptionAmountSuffix1("monthly");
                }}
              >
                Monthly
              </Radio>
              <Radio
                value="2"
                onClick={() => {
                  setSubscriptionAmountSuffix1("quarterly");
                }}
              >
                Quarterly
              </Radio>
              <Radio
                value="3"
                onClick={() => {
                  setSubscriptionAmountSuffix1("half-yearly");
                }}
              >
                Half Yearly
              </Radio>
            </Stack>
          </RadioGroup>
        </Box> */}
        <Flex
          className="plan-block"
          margin={"5px 15px"}
          justifyContent={"space-around"}
          display={"flex"}
        >
          {pricingLoading || !pricingData ? (
            <Loader />
          ) : (
            pricingData.map((paymentPlan) => (
              <Box className="plan-container">
                <Box>
                  <Flex
                    borderTopRadius={"12px"}
                    justifyContent={"space-around"}
                    display={"flex"}
                    alignItems={"center"}
                    backgroundColor={
                      paymentPlan?.planName.bgColor
                        ? paymentPlan?.planName.bgColor
                        : ""
                    }
                    padding={"5px"}
                  >
                    {paymentPlan?.planName?.endIcon && (
                      <Box style={{ margin: "0px 5px" }}>
                        {paymentPlan?.planName?.startIcon ===
                          "SMMProStartIcon" && <SMMProStartIcon />}
                      </Box>
                    )}
                    <Box
                      className="plan-title"
                      color={paymentPlan?.planName.fontColor}
                      fontSize={paymentPlan?.planName.fontSize}
                    >
                      {paymentPlan?.planName.label}
                    </Box>
                    {paymentPlan?.planName?.endIcon && (
                      <Box style={{ margin: "0px 5px" }}>
                        {paymentPlan?.planName?.endIcon === "SMMBasicIcon" && (
                          <SMMBasicIcon />
                        )}
                        {paymentPlan?.planName?.endIcon === "SMMProEndIcon" && (
                          <SMMProEndIcon />
                        )}
                      </Box>
                    )}
                  </Flex>
                  {paymentPlan?.priceRange &&
                    paymentPlan?.priceRange.account.amount > 0 &&
                    subscriptionOffer?.offerDiscountPer && (
                      <Box
                        className="plan-title"
                        color={"#0C543C"}
                        padding={"5px"}
                        textAlign={"center"}
                        m={"5px 10px"}
                      >
                        {subscriptionOffer?.offerDiscountPer}% discount applied
                      </Box>
                    )}
                  {paymentPlan?.priceRange && (
                    <>
                      <Box m={"5px 10px"}>
                        <Flex justifyContent={"center"} padding={"0px"}>
                          <Box
                            fontSize={paymentPlan?.priceRange.account.fontSize}
                            fontWeight={"400"}
                            color={paymentPlan?.priceRange.account.fontColor}
                          >
                            ₹
                          </Box>
                          <Flex
                            alignItems={"center"}
                            fontSize={"29px"}
                            fontWeight={"700"}
                            color={paymentPlan?.priceRange.account.fontColor}
                          >
                            <Box
                              className="plan-title"
                              color={paymentPlan?.priceRange.account.fontColor}
                              padding={"5px"}
                              textAlign={"center"}
                              fontSize={
                                paymentPlan?.priceRange.account.fontSize
                              }
                            >
                              {subscriptionOffer?.offerDiscountPer
                                ? (paymentPlan?.priceRange.account.amount *
                                  (100 - subscriptionOffer?.offerDiscountPer)/100).toFixed(0)
                                : paymentPlan?.priceRange.account.amount}
                            </Box>
                            <Box fontSize={"13px"} fontWeight={"600"}>
                              {paymentPlan?.priceRange.account.label}
                            </Box>
                          </Flex>
                        </Flex>
                        {subscriptionOffer?.offerDiscountPer &&
                          paymentPlan?.priceRange.account.amount > 0 && (
                            <Flex justifyContent={"center"} padding={"0px"}>
                              <Box
                                fontSize={"13px"}
                                fontWeight={"400"}
                                color={"#5D5D5D"}
                              >
                                ₹
                              </Box>
                              <Flex
                                alignItems={"center"}
                                fontSize={"29px"}
                                fontWeight={"700"}
                                color={"#5D5D5D"}
                              >
                                <Box>
                                  <Box
                                    className="plan-title"
                                    color={"#0C543C"}
                                    padding={"5px"}
                                    textAlign={"center"}
                                    textDecoration="line-through"
                                  >
                                    {paymentPlan?.priceRange.account.amount}
                                  </Box>
                                </Box>
                              </Flex>
                            </Flex>
                          )}
                      </Box>
                    </>
                  )}
                  {paymentPlan?.priceRange?.account &&
                  paymentPlan?.priceRange?.account.amount !== 0 ? (
                    <Flex justifyContent={"center"} margin={"10px"}>
                      {selectedPlan === paymentPlan?._id ? (
                        <Text>Processing please wait...</Text>
                      ) : (
                        <Button
                          bgColor={"#5D5D5D"}
                          h={"33px"}
                          w={"100%"}
                          fontSize={"14px"}
                          fontWeight={"700"}
                          onClick={() => {
                            setSubscriptionAmount(
                              paymentPlan?.priceRange.account?.amount
                            );
                            handlePayment(paymentPlan);
                          }}
                        >
                          Get Started
                        </Button>
                      )}
                    </Flex>
                  ) : (
                    <></>
                    // <Flex
                    //   fontSize={"14px"}
                    //   fontWeight={"700"}
                    //   justifyContent={"center"}
                    //   margin={"10px"}
                    // >
                    //   Coming Soon
                    // </Flex>
                  )}
                  <Box className="plan-content">
                    {paymentPlan?.planDescription && (
                      <Box
                        fontSize={paymentPlan?.planDescription.fontSize}
                        fontWeight={"500"}
                        color={paymentPlan?.planDescription.fontColor}
                        mb={"10px"}
                      >
                        {paymentPlan?.planDescription.label}
                      </Box>
                    )}
                    <Box>
                      {paymentPlan?.content &&
                        paymentPlan?.content.map((item) => (
                          <>
                            <Flex
                              justifyContent={"start"}
                              alignItems={"center"}
                              mb={item?.points ? "0px" : "5px"}
                            >
                              <Box style={{ margin: "0px 5px" }}>
                                {item.icon === "check" && <CheckIcon />}
                                {item.icon === "cross" && <CrossIcon />}
                              </Box>
                              <Box
                                fontSize={item.fontSize}
                                fontWeight={"400"}
                                color={item.fontColor}
                              >
                                {item.label}
                              </Box>
                            </Flex>
                            {item?.points && item?.points.type === "bullet" ? (
                              <Box ml="24px" mb="5px">
                                <List styleType="disc" pl={4}>
                                  {item?.points.contents.map((subitem) => (
                                    <ListItem
                                      fontSize={subitem.fontSize}
                                      color={subitem.fontColor}
                                    >
                                      {subitem.label}
                                    </ListItem>
                                  ))}
                                </List>
                              </Box>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))
          )}
        </Flex>
      </ModalBody>
    </ModalContent>
  );
};

const Step3Component = () => {
  return (
    <ModalContent py="10" px="15" position="relative">
      <ModalCloseButton
        position="absolute"
        top="-15px"
        height="42px"
        width="42px"
        right="-15px"
        background="#fff"
        borderRadius="50px"
        boxShadow="-4px -4px 18px rgba(0, 0, 0, 0.4)"
      />
      <ModalBody>
        <Flex flexDir="column" justifyContent="center" alignItems="center">
          <Heading fontSize="28px" fontWeight="600" color="#0C543C">
            Congratulations on your purchase!
          </Heading>
          <Box mt={8} mb={14}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="34"
              viewBox="0 0 32 34"
              fill="none"
            >
              <path
                d="M8 0C3.55556 0 0 3.55556 0 8C0 12.4444 3.55556 16 8 16C11.5556 16 14.4 13.8667 15.4667 10.6667H21.3333V16H26.6667V10.6667H32V5.33333H15.4667C14.4 2.13333 11.5556 0 8 0ZM8 5.33333C9.42222 5.33333 10.6667 6.57778 10.6667 8C10.6667 9.42222 9.42222 10.6667 8 10.6667C6.57778 10.6667 5.33333 9.42222 5.33333 8C5.33333 6.57778 6.57778 5.33333 8 5.33333ZM16 19.5556L14.0444 24.1778L8.88889 24.7111L12.8 28.0889L11.5556 33.0667L16 30.4L20.2667 33.0667L19.2 28.0889L23.1111 24.7111L17.9556 24.3556L16 19.5556Z"
                fill="#8F8F8F"
              />
            </svg>
          </Box>
          <Text fontSize="16px" fontWeight="400" color="#000">
            To make the most out of your newly acquired dashboards, visit{" "}
            <Link textDecor="underline">https://link</Link>
          </Text>
        </Flex>
      </ModalBody>
    </ModalContent>
  );
};

export default function PaymentModal() {
  const { isShowPaymentModal, hidePaymentModal } = usePayment();
  const [step, setStep] = useState(2);

  return (
    <>
      <Modal
        size="4xl"
        isOpen={isShowPaymentModal}
        onClose={() => {
          setStep(2);
          hidePaymentModal();
        }}
        isCentered
      >
        <ModalOverlay />
        {step === 1 && <Step1Component setStep={setStep} />}

        {step === 2 && <StepPlanSubcriptionComponent setStep={setStep} />}
        {/* {step === 2 && <Step2Component setStep={setStep} />} */}

        {step === 3 && <Step3Component setStep={setStep} />}
      </Modal>
    </>
  );
}
